import styled from 'styled-components';
import Tooltip from 'react-simple-tooltip';
import {
  QuestionTooltipBlock,
} from '../HotelPanel/styles';

export const QuestionTooltipBlockBooking = styled(QuestionTooltipBlock)`
  margin: 0;
`;

export const BookingPanelArticle = styled.article`
  padding-top: 55px;
  padding-bottom: 30px;

  background-color: ${({ theme }) => theme.white};

  @media(min-width: 768px) {
    grid-column: 2;
    grid-row: 1 / 5;
    padding: 0 30px;
    padding-top: 40px;
    padding-bottom: 30px;

    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }

  @media (min-width: 1024px) {
    grid-column: 3;
    grid-row: auto;
  }

  @media (min-width: 1024px) and (min-height: 1100px) {
    position: sticky;
    top: 120px;
    z-index: 1;
  }
`;

export const BookingInfo = styled.div`
  margin-bottom: 50px;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const ServiceFeeToolTipBooking = styled(Tooltip)`
  z-index: 1;
  transform: none !important;
  position: absolute !important;
  padding-right: 0 !important;
  margin-left: 10px;

  & > div:not(:first-child) {
    width: 230px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);

    div {
      text-align: left !important;
      & > div {
        padding-right: 0 !important;
      }
    }
  }
`;

export const BookingList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  &:not(:last-child) {
    margin-bottom: 18px;
  }
`;

export const BookingItem = styled.li`
  display: flex;
  align-items: flex-start;
  min-height: 25px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const BookingIcon = styled.div`
  width: 25px;
  flex-shrink: 0;
  margin-right: 15px;

  font-size: 0;
  text-align: center;

  svg {
    color: ${({ theme }) => theme.lightGray};
    transform: scale(0.9)
  }
`;

export const BookingPanelTable = styled.ul`
  width: 100%;

  font-size: 16px;
  line-height: 1;

  li {
    display: flex;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 5px;
  }

  small {
    font-size: 14px;
    color: #808080;
  }

  hr {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  span {
    font-weight: 700;
    font-size: 24px;
  }

  div {
    &:first-child {
      flex-grow: 1;
      padding-right: 50px;
    }

    &:last-child {
      text-align: right;
    }
  }
`;

export const BookingId = styled.p`
  margin: 0;
  margin-top: 10px;
  margin-bottom: 25px;
  padding: 0;
  font-size: 12px;
  line-height: 1;
  text-align: center;

  span {
    font-weight: 700;
    text-transform: uppercase;
  }
`;

export const Divider = styled.hr`
  margin-top: 20px;
  margin-bottom: 20px;

  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.lightGray};
`;

export const StatusIcon = styled.span`
  display: block;
  margin-right: 10px;
  padding: 5px 13px;

  font-weight: 700;
  font-size: 12px;
  text-align: center;
  color: ${({ theme }) => theme.white};

  border-radius: 50px;

  background: ${({ theme, status }) => {
    switch (Number(status)) {
      case 0:
        return theme.green;
      case 2:
      case 3:
      case 4:
        return theme.blue;
      default:
        return theme.red;
    }
  }};
`;

export const ValidateButtonContainer = styled.div`
  position: fixed;
  z-index: 1;
  left: 0;
  bottom: 0;

  width: 100%;
  padding: 30px 25px;

  background-color: ${({ theme }) => theme.white};

  button {
    width: 100%;
  }

  p {
    color: ${({ theme }) => theme.red};
    text-align: center;
  }

  @media (min-width: 768px) {
    position: static;

    margin-top: 30px;
    padding: 0;

    background-color: transparent;
  }
`;

export const PromoContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const PromoIcon = styled.div`
  width: 35px;
  flex-shrink: 0;
  margin-right: 20px;
`;

export const PromoInfo = styled.div`
  display: flex;
  flex-direction: column;

  font-size: 14px;
`;

export const PromoHeading = styled.p`
  margin: 0;
  margin-bottom: 5px;
  padding: 0;

  font-weight: 700;
`;

export const PromoDescription = styled.p`
  margin: 0;
  padding: 0;

  line-height: 18px;
`;
